<template>
  <div class="receptionOverflow">
    <div v-loading="loadStatus" class="stage-order-settlement" element-loading-background="rgba(255, 255, 255, 1)">
      <gt-customerInfo :member-info="customerMsg.memberMsg" :search-val="customerMsg.phone" :refresh-data="refreshData"></gt-customerInfo>
      <div v-if="serviceItems.serveItemsList" class="margin-top-20">
        <el-collapse v-model="serviceNames">
          <el-collapse-item title="消费清单" name="1">
            <yz-consumption-list :service-items="serviceItems" :product-sales="productSales" :vip-card="vipCard" :consumption-list="consumptionList"></yz-consumption-list>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div v-if="!isPartPay">
        <div v-if="(memberMsg && memberMsg.fansCurrency && memberMsg.fansCurrency != 0) || (memberMsg && memberMsg.integral && memberMsg.integral != 0) || memberMsg.cardList || memberMsg.appointCardList" class="new_box">
          <div class="new_box_title">选择抵扣优惠</div>
          <div class="content">
            <yz-coupon :book-amount="bookAmount" :member-msg="memberMsg" :total-money="totalMoney" :product-sales="productSales" :service-items="serviceItems" :wholesale-price="wholesalePrice" @getConponMsg="getConponMsg"></yz-coupon>
          </div>
        </div>
      </div>

      <div class="new_box">
        <div class="new_box_title">结算信息</div>
        <div class="content">
          <yz-settlement-msg :edit-price-val="isPartPay" :change-coupon="changeCoupon" :settlement-msg="settlementMsg" :customer-msg="customerMsg" :change-discount-money="changeDiscountMoney" :member-discount-money="memberDiscountMoney" :deduction-amount="deductionAmount" :order-change-money="orderChangeMoney" :part-pay-total="partPayTotal" :init-amount="initAmount" :book-amount="bookAmount" :gift-discount="giftDiscount" :buy-gift-discount="buyGiftDiscount" :satisfy-gift-discount="satisfyGiftDiscount" :gift-deduct="giftDeduct" :electronic-ticket-deduct="electronicTicketDeduct" :wholesale-price="wholesalePrice" :activity-price-list="activityPriceList" @getSettlementMsg="getSettlementMsg"></yz-settlement-msg>
        </div>
      </div>
      <div class="new_box">
        <div class="new_box_title">选择收银方式</div>
        <div class="content">
          <yz-pay-method ref="payMethods" :edit-money-val="editMoneyVal" :pay-methods="payMethods" :settlement-msg="settlementMsg" :on-account-auth="onAccountAuth*1" :is-part-pay="isPartPay" :customer-msg="customerMsg" :wholesale-price="wholesalePrice" :dto-list="dtoList" :btn-disable="btnDisable" @getPayMethodsMsg="getPayMethodsMsg"></yz-pay-method>
        </div>
      </div>
      <div class="save-bts">
        <el-button v-if="dtoList.length > 0" type="primary" :disabled="savePayLoading1" @click="toPay('room')">确认买单并{{ getRoomType == 1 ? '退房' : '退位' }}</el-button>
        <el-button type="primary" :disabled="savePayLoading1" @click="toPay('88')">确认买单</el-button>
        <!-- <el-button type="primary" @click="toPayAndPrint" :disabled="savePayLoading2">确认并打印</el-button> -->
        <el-button @click="cancleOrder">取消</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import YzCoupon from './template/coupon';
import YzSettlementMsg from './template/settlementMsg';
import YzPayMethod from './template/payMethod';
import YzConsumptionList from './template/consumptionList';

import { getOrderBillingMsg } from './api';
// import { percentagePineOption } from '../../../../../../app/src/views/form/exchart_form/percentageMap';

export default {
  components: {
    YzCoupon,
    YzSettlementMsg,
    YzPayMethod,
    YzConsumptionList
  },
  data() {
    return {
      serviceNames: [],
      productNames: [],
      loadStatus: true,
      id: '',
      customerMsg: {
        cardNo: '',
        memberName: '',
        memberMsg: {},
        phone: '',
        money: '',
        integral: '',
        fansCurrency: '',
        gradeName: ''
      },
      serviceItems: {},
      productSales: {},
      vipCard: {},
      show: false,
      payMethods: {
        orderId: '',
        money: '',
        discountMoney: '',
        cardNo: '',
        orderCode: '',
        ctName: ''
      },
      memberMsg: {},
      memberType: '',
      totalMoney: '',
      settlementMsg: '',
      onAccountAuth: 0,
      payType: '',
      savePayLoading1: true,
      savePayLoading2: false,

      isPartPay: 0, // 是否是部分支付  0不是  1是
      balance: '',
      editMoneyVal: 0, // 改价的金额
      changeCoupon: false,

      changeDiscountMoney: 0, // 改价优惠
      memberDiscountMoney: 0, // 会员优惠
      deductionAmount: 0, // 套餐划扣
      orderChangeMoney: 0, // 整单改价优惠
      partPayTotal: 0, // 部分支付应还金额
      initAmount: 0, // 消费总额
      bookAmount: 0, // 已收定金
      giftDiscount: 0, // 6.1赠送优惠总额
      buyGiftDiscount: 0, // 6.5买赠优惠总额
      giftDeduct: 0, // 赠送划扣金额

      // 6.3
      electronicTicketDeduct: 0, // 电子票划扣金额
      wholesalePrice: 0, // 拿货宝总额

      // 6.4
      activityPriceList: [], // 活动优惠列表

      // 6.6
      satisfyGiftDiscount: 0, // 6.6满赠优惠总额
      // 6.8
      getRoomType: window.sessionStorage.tidyStatus, // 设置的房态  1房间  2床位  3台位(5.10)
      dtoList: []
    };
  },
  activated() {
    this.isPartPay = this.$route.params.partPay;
    this.id = window.sessionStorage.settlementOrderId; // 订单id
    this.getOrderBillingMsg();
    this.loadStatus = true;
    this.savePayLoading1 = true;
    this.savePayLoading2 = true;
    this.editMoneyVal = 0;
  },
  methods: {
    refreshData() {
      this.getOrderBillingMsg();
    },
    getOrderBillingMsg() {
      getOrderBillingMsg({ id: this.id }).then((res) => {
        if (res.code == 0) {
          this.show = true;
          const { data } = res;
          // 顾客信息
          this.customerMsg = {
            cardNo: data.cardNo,
            memberName: data.memberName,
            memberMsg: data.memberMsg,
            phone: data.phone,
            money: data.memberMsg ? data.memberMsg.money : '',
            integral: data.memberMsg ? data.memberMsg.integral : '',
            fansCurrency: data.memberMsg ? data.memberMsg.fansCurrency : '',
            gradeName: data.memberMsg ? data.memberMsg.gradeName : ''
          };
          this.memberType = data.memberType;
          // 服务项目
          if (data.serveItemsList) {
            data.serveItemsList.forEach((item1) => {
              item1.newPrice = 0;
            });
          }
          this.serviceItems = {
            serveItemsList: data.serveItemsList ? data.serveItemsList : [],
            itemsSumTotal: data.itemsSumTotal
          };
          // 产品销售
          if (data.productSalesList) {
            data.productSalesList.forEach((item2) => {
              item2.newPrice = 0;
            });
          }
          this.productSales = {
            productSalesList: data.productSalesList ? data.productSalesList : [],
            productsSumTotal: data.productsSumTotal
          };
          // 套餐购买
          if (data.vipCardList) {
            data.vipCardList.forEach((item3) => {
              item3.newPrice = 0;
            });
          }
          this.vipCard = {
            vipCardList: data.vipCardList ? data.vipCardList : [],
            packageSumTotal: data.packageSumTotal
          };

          const arr = [];
          this.serviceItems.serveItemsList.forEach((a) => {
            a.listStatus = 1;
            arr.push(a);
          });
          this.productSales.productSalesList.forEach((b) => {
            b.listStatus = 2;
            b.resultPrice = b.total;
            arr.push(b);
          });
          this.vipCard.vipCardList.forEach((c) => {
            c.listStatus = 3;
            arr.push(c);
          });
          data.giftItemList.forEach((d) => {
            d.count = d.givingQuantity;
            d.discount = (d.memberPrice / d.price * 10).toFixed(2);
            d.discountMoney = d.memberPrice;
            d.isGift = d.activityId ? d.activityType == 3 ? 2 : d.activityType == 4 ? 3 : 1 : 1;
            d.isGiftDeduct = 0;
            d.itemName = d.giftName;
            d.listStatus = 1;
            d.newPrice = 0;
            d.oldPrice = d.price;
            d.percentage4ServeList = [];
            d.percentageSellServeList = [];
            d.percentage4ProductList = [];
            d.percentage4PackageList = [];
            d.resultPrice = (d.memberPrice * d.givingQuantity).toFixed(2);
            arr.push(d);
          });
          data.giftProductList.forEach((e) => {
            e.count = e.givingQuantity;
            e.discount = (e.memberPrice / e.price * 10).toFixed(2);
            e.discountMoney = e.memberPrice;
            e.isGift = e.activityId ? e.activityType == 3 ? 2 : e.activityType == 4 ? 3 : 1 : 1;
            e.isGiftDeduct = 0;
            e.productName = e.giftName;
            e.listStatus = 2;
            e.newPrice = 0;
            e.oldPrice = e.price;
            e.percentage4ServeList = [];
            e.percentageSellServeList = [];
            e.percentage4ProductList = [];
            e.percentage4PackageList = [];
            e.resultPrice = (e.memberPrice * e.givingQuantity).toFixed(2);
            arr.push(e);
          });
          data.giftPackageList.forEach((f) => {
            f.count = f.givingQuantity;
            f.discount = (f.memberPrice / f.price * 10).toFixed(2);
            f.discountMoney = f.memberPrice;
            f.isGift = f.activityId ? f.activityType == 3 ? 2 : f.activityType == 4 ? 3 : 1 : 1;
            f.isGiftDeduct = 0;
            f.vipCardName = f.giftName;
            f.listStatus = 3;
            f.newPrice = 0;
            f.oldPrice = f.price;
            f.percentage4ServeList = [];
            f.percentageSellServeList = [];
            f.percentage4ProductList = [];
            f.percentage4PackageList = [];
            f.resultPrice = (f.memberPrice * f.givingQuantity).toFixed(2);
            arr.push(f);
          });
          console.log(arr);
          this.consumptionList = arr;

          // 支付方式
          this.payMethods = {
            orderId: this.id,
            money: '',
            memberMoney: data.memberMsg ? data.memberMsg.money : '',
            discountMoney: '',
            cardNo: data.cardNo,
            orderCode: data.orderCode,
            ctName: data.memberMsg ? (data.memberMsg.ctName ? data.memberMsg.ctName : '') : ''
          };
          // 选择优惠券
          this.memberMsg = data.memberMsg ? data.memberMsg : {};
          this.totalMoney = (data.itemsSumTotal * 1 + data.productsSumTotal * 1 + data.packageSumTotal * 1 + data.wholesalePrice * 1 - data.bookAmount * 1).toFixed(2);
          // 部分支付
          this.isPartPay = data.partPayType;
          this.balance = data.balance;
          // 结算信息
          this.settlementMsg = window.JSON.stringify({
            totalMoney: this.isPartPay == 1 ? this.balance : this.totalMoney,
            resulteMoney: this.isPartPay == 1 ? this.balance : this.totalMoney,
            money: data.memberMsg ? data.memberMsg.money : '',
            others: {
              couponMsg: {
                money: this.isPartPay == 1 ? res.data.couponMoney : 0,
                num: 0,
                cardId: ''
              },
              fenBiMsg: {
                money: this.isPartPay == 1 ? res.data.fenbiMoney : 0,
                num: 0
              },
              jifenMsg: {
                money: this.isPartPay == 1 ? res.data.integralMoney : 0,
                num: 0
              },
              // giftDeductMsg: {
              //   money: this.isPartPay == 1 ? res.data.giftDeduct : 0,
              //   num: 0
              // }
            }
          });
          this.onAccountAuth = data.onAccountAuth;
          // 优惠金额
          this.orderChangeMoney = data.orderChangeMoney * 1;
          this.partPayTotal = data.partPayTotal * 1;
          this.initAmount = data.initAmount;
          this.wholesalePrice = data.wholesalePrice * 1;
          this.bookAmount = data.bookAmount * 1;
          this.changeDiscountMoney = data.changeDiscountMoney * 1;
          this.memberDiscountMoney = data.memberDiscountMoney * 1;
          this.deductionAmount = data.deductionAmount * 1;
          this.giftDiscount = data.giftDiscount * 1;
          this.buyGiftDiscount = data.buyGiftDiscount * 1;
          this.satisfyGiftDiscount = data.satisfyGiftDiscount * 1;
          this.giftDeduct = data.giftDeduct * 1;
          this.activityPriceList = data.activityPriceList;
          // 6.3
          this.electronicTicketDeduct = data.electronicTicketDeduct * 1;

          // 6.8
          this.dtoList = data.dto ? data.dto.checkInList ? data.dto.checkInList : [] : [];
          setTimeout(() => {
            this.savePayLoading1 = false;
            this.savePayLoading2 = false;
          }, 1000);
          this.loadStatus = false;
        }
      });
    },
    // 获取优惠券信息
    getConponMsg(obj) {
      this.changeCoupon = !this.changeCoupon;
      this.settlementMsg = window.JSON.stringify({
        totalMoney: window.parseFloat(this.isPartPay == 1 ? this.balance : this.totalMoney).toFixed(2),
        resulteMoney: window.parseFloat(obj.resulteMoney).toFixed(2),
        others: obj
      });
      this.savePayLoading1 = false;
    },
    // 获取支付方式数据
    getPayMethodsMsg(obj) {
      this.payType = obj.payType;
      this.savePayLoading1 = obj.disable;
      this.savePayLoading2 = obj.disable;
    },
    // 获取结算信息数据
    getSettlementMsg(obj) {
      this.settlementMsg = window.JSON.stringify({
        totalMoney: window.parseFloat(this.isPartPay == 1 ? this.balance : this.totalMoney).toFixed(2),
        resulteMoney: window.parseFloat(obj.resulteMoney).toFixed(2),
        others: obj
      });
      this.editMoneyVal = obj.editMoneyVal * 1;
      if (this.savePayLoading2 == false) {
        this.savePayLoading1 = false;
      }
    },
    // 确认买单
    toPay(val) {
      this.savePayLoading1 = true;
      this.$refs.payMethods.toPay(val);
    },
    // 按钮禁用解除
    btnDisable() {
      this.savePayLoading1 = false;
    },
    // 取消
    cancleOrder() {
      this.$store.commit('deleteTabs', 'stage-orderSettlement');
      this.$router.push({
        name: 'stage-index'
      });
    }
  }
};
</script>

<style lang="less" scoped>
.stage-order-settlement {
  font-size: 14px;
  min-height: 500px;
}
.table-title {
  border-bottom: 1px solid #e6ebf5;
  padding-bottom: 10px;
  font-weight: 700;
  color: #000000;
  margin-bottom: 20px;
}
.margin-top-30 {
  margin-top: 30px;
}
.margin-top-20 {
  margin-top: 20px;
}
.save-bts {
  margin: 50px 0 30px;
}
.new_box {
  margin-top: 20px;
  border: 1px solid #ebeef5;
  .new_box_title {
    background-color: #f5f7fa;
    height: 44px;
    line-height: 44px;
    color: #999;
    padding: 0 20px 0 30px;
  }
  .content {
    padding: 10px 20px 20px;
  }
}
</style>
